import { PureComponent } from "react";
import ParagraphAndAssetColumnsComponent from "/components/core/paragraph-and-asset-columns/paragraph-and-asset-columns-component";
import StarsComponent from "components/core/stars/stars-component";
import { StyledCustomerSuccessComponent } from "./customer-success-component.scss";

export default class CustomerSuccessComponent extends PureComponent {
  render() {
    const { columnWidth, imageWidth } = this.props;

    return (
      <StyledCustomerSuccessComponent className={`customer-success-component`}>
        {this.props.assets.map((assetAndParagaph, index) => {
          const { stars } = assetAndParagaph;
          const { showStars } = stars || {};

          return (
            <div className="customer-success-item-wrapper" key={index}>
              <ParagraphAndAssetColumnsComponent
                {...assetAndParagaph}
                columnWidth={columnWidth}
                imageWidth={imageWidth}
              />

              {showStars && <StarsComponent {...stars} />}
            </div>
          );
        })}
      </StyledCustomerSuccessComponent>
    );
  }
}

CustomerSuccessComponent.defaultProps = {
  columnWidth: "240px",
  imageWidth: "200px",
  assets: [
    {
      asset: {
        shadow: false,
        image: {
          src: "/static/img/customer-success/tan.png",
          alt: "Webinars"
        }
      },
      content: {
        title: "Webinars",
        textDirection: "center",
        body: ["On-demand or live, get in-depth knowledge on a variety of topics"],
        bottomLink: {
          text: "Attend a webinar",
          href: "/webinars"
        }
      }
    },
    {
      asset: {
        shadow: false,
        image: {
          src: "/static/img/customer-success/shira.png",
          alt: "Articles"
        }
      },
      content: {
        title: "Articles",
        textDirection: "center",
        body: ["If words are more your thing, read up on all things why, how and what"],
        bottomLink: {
          text: "Read an article",
          href: "/support"
        }
      }
    },
    {
      asset: {
        shadow: false,
        image: {
          src: "/static/img/customer-success/omri.png",
          alt: "Tutorials"
        }
      },
      content: {
        title: "Tutorials",
        textDirection: "center",
        body: ["Funny and functional, our tutorials will take you through every process step-by-step"],
        bottomLink: {
          text: "Watch a tutorial",
          href: "/guides"
        }
      }
    }
  ]
};
